var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerpoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ED6C47;}\n\t.st1{fill:#FF8F6B;}\n\t.st2{fill:#D35230;}\n\t.st3{opacity:0.1;enable-background:new    ;}\n\t.st4{opacity:0.2;enable-background:new    ;}\n\t.st5{fill:#C43E1C;}\n\t.st6{fill:#F9F7F7;}\n\t.st7{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STYLE_COLOR"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31,9c-11.6,0-21,9.4-21,21l26.6,5.6L31,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31,9c11.6,0,21,9.4,21,21l-10.5,7.1L31,30V9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31,51c11.6,0,21-9.4,21-21H10C10,41.6,19.4,51,31,51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29,16.5H15C7.8,24.9,8.5,37.4,16.4,45H29c1.1,0,2-0.9,2-2V18.5C31,17.4,30.1,16.5,29,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27.5,18H13.8c-6.4,9.1-4.5,21.7,4.3,28.5h9.4c1.1,0,2-0.9,2-2V20C29.5,18.9,28.6,18,27.5,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27.5,18H13.8c-5.5,7.8-5,18.3,1.1,25.5h12.5c1.1,0,2-0.9,2-2V20C29.5,18.9,28.6,18,27.5,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26,18H13.8c-5.5,7.8-5,18.3,1.1,25.5h11c1.1,0,2-0.9,2-2V20C28,18.9,27.1,18,26,18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Back_Plate",
    className: "st5",
    d: "M6,18h20c1.1,0,2,0.9,2,2v20c0,1.1-0.9,2-2,2H6c-1.1,0-2-0.9-2-2V20C4,18.9,4.9,18,6,18L6,18z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M16,22.5c1.5-0.1,2.9,0.3,4.1,1.2c1,0.9,1.5,2.2,1.4,3.5c0,0.8-0.2,1.7-0.7,2.4c-0.5,0.8-1.2,1.4-2,1.8 c-0.9,0.4-2,0.7-3,0.6h-2.9v5.5H10v-15H16z M12.9,29.5h2.5c0.8,0.1,1.6-0.2,2.2-0.7c0.5-0.3,0.8-0.9,0.8-1.5c0-1.7-1-2.5-2.9-2.5 h-2.6V29.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    className: "st7",
    width: 48,
    height: 48
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpoint);
export default __webpack_public_path__ + "static/media/powerpoint.1f3a059f4440164eab2ef8856daa6023.svg";
export { ForwardRef as ReactComponent };